import { makeStyles } from '@material-ui/core'


const DashboardDetailsTheme = makeStyles((theme) => ({
    main: {
        background: '#EFF1F2',
        height: '100vh'
    },
    gridGrafico: {
        display: "flex",
        width: "100%",
        height: "100%",
        justifyContent: "center",
        alignItems: "center",
    },
    gridDados: {
        isplay: "flex",
        lexDirection: "column",
        ustifyContent: "space-between",
    },
    fundoGrafico: {
        width: "100%",
        height: "100%",
        borderRadius: "10px",
        boxSizing: "border-box",
        boxShadow: " -5px 8px 10px rgba(87, 120, 131, 0.2);",
    },
    botoes: {
        display: "flex",
        justifyContent: "flex-end",
        marginTop: "10px",
    },
    gridItem: {
        background: "#0fa",
        display: "flex",
        flexDirection: "column",
        minHeight: "100%",
        "& > *": {
            minHeight: "100%",
        },
    },
    modalCarregamento: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        height: "100%",
        width: "100%",
    },
    linhaDeProgresso: {
        position: "fixed",
        top: "9.8%",
        width: "100%",
        height: "0.5%",
        zIndex: 10
    },
    gridProgressBar: {
        marginTop: '20px',
        maxHeight: '50%',
        overflowY: 'auto'
    },
    progressBarContainer: {
        width: '100%',
        padding: '20px',
        boxSizing: "border-box",
        borderRadius: "5px",
        boxShadow: " -5px 8px 10px rgba(87, 120, 131, 0.2);",
    },
    h2: {
        margin: 0,
        paddingBottom: '5px',
        borderBottom: '1px solid rgba(0,0,0,.15)'
    },
    noErrorContainer: {
        borderStyle: 'dashed',
        borderRadius: '5px',
        borderColor: '#d9d9d9',
        borderWidth: '2px',
        margin: '20px 0px',
    },
    noErrorText: {
        textAlign: 'center',
        color: '#7373738c',
        fontSize: '20px',
        fontWeight: '600',
    }
}));

export default DashboardDetailsTheme;